import { jsonApiAxios, useHandleError } from '../../services/api';
import { useCoBrandingParams } from '../../hooks/useCobrandingParams';
import useAuthenticate from '../../hooks/useAuthenticate';
import { useCallback } from 'react';
import { LetterTypes } from '../../views/Permission/PermissionDescription';

export function useDownloadPoaOrPPoa({
  passengerId,
  placeOfJurisdictionId,
}: {
  passengerId: string | undefined;
  placeOfJurisdictionId?: string;
}) {
  const { token, isLoggedIn } = useAuthenticate();
  const [handleError] = useHandleError();
  const { dynamicConfig } = useCoBrandingParams();

  return useCallback(
    (type: LetterTypes) => {
      if (passengerId) {
        jsonApiAxios
          .get(
            `/passengers/${passengerId}/blankSignableLetter?filter[type]=${type}`,
            {
              ...(!isLoggedIn
                ? {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  }
                : {}),
              responseType: 'arraybuffer',
            }
          )
          .then(res => {
            window.open(
              window.URL.createObjectURL(
                new Blob([res.data], { type: 'application/pdf' })
              )
            );
          })
          .catch(error => {
            handleError(error);
          });
      } else {
        if (type === 'partner-power-of-attorney') {
          window.open(
            `${dynamicConfig?.blankPartnerPowerOfAttorneyUrl}?filter[place_of_jurisdiction.id]=${placeOfJurisdictionId}`
          );
        } else {
          window.open(dynamicConfig?.blankPowerOfAttorneyUrl);
        }
      }
    },
    [
      dynamicConfig,
      handleError,
      isLoggedIn,
      passengerId,
      placeOfJurisdictionId,
      token,
    ]
  );
}
